import { TableSchema } from '../metadata-schema';
import { dim_br_brin } from './dim_br_brin';
import { dim_ilt_opleidingscode } from './dim_ilt_opleidingscode';
import { instelling } from './instelling';
import { fac_lb_loopbaan } from './fac_lb_loopbaan';
import { dim_ll_leerling } from './dim_ll_leerling';
import { dim_mw_medewerker } from './dim_mw_medewerker';
import { fac_or_onderwijsresultaten } from './fac_or_onderwijsresultaten';
import { dim_pc_postcode } from './dim_pc_postcode';
import { dim_vs_vestiging } from './dim_vs_vestiging';
import { DoorstroomExt } from '../enums/DoorstroomExt';
import { Niveau } from '../enums/Niveau';
import { Onderwijstype } from '../enums/Onderwijstype';
import { Overgangmoment } from '../enums/Overgangmoment';
import { CategorieUitstroomniveauVSO } from '../enums/CategorieUitstroomniveauVSO';
import { VergelijkingUitstroomniveauVSO } from '../enums/VergelijkingUitstroomniveauVSO';
import { Examenstatus } from '../enums/Examenstatus';
import { ExamenstatusMetPrognose } from '../enums/ExamenstatusMetPrognose';
import { BovenbouwsuccesUitzondering } from '../enums/BovenbouwsuccesUitzondering';
import { Bekostigingstype } from '../enums/Bekostigingstype';
import { CohortrendementTotWaarde } from '../enums/CohortrendementTotWaarde';
import { CohortrendementTotDoublure } from '../enums/CohortrendementTotDoublure';
import { CohortrendementTotNiveau } from '../enums/CohortrendementTotNiveau';
import { CohortrendementVanafWaarde } from '../enums/CohortrendementVanafWaarde';
import { CohortrendementVanafDoublure } from '../enums/CohortrendementVanafDoublure';
import { CohortrendementVanafNiveau } from '../enums/CohortrendementVanafNiveau';
import { CohortstatusVanaf } from '../enums/CohortstatusVanaf';
import { EinduitstroomVSOStatus } from '../enums/EinduitstroomVSOStatus';
import { DoorstroomResultaat } from '../enums/DoorstroomResultaat';
import { Instroom } from '../enums/Instroom';
import { Instroomtype } from '../enums/Instroomtype';
import { OnderbouwsnelheidUitzondering } from '../enums/OnderbouwsnelheidUitzondering';
import { OnderwijspositieStatus } from '../enums/OnderwijspositieStatus';
import { OnderwijspositieUitzondering } from '../enums/OnderwijspositieUitzondering';
import { PlaatsingUitzondering } from '../enums/PlaatsingUitzondering';
import { PrestatieanalyseVSOUitzondering } from '../enums/PrestatieanalyseVSOUitzondering';
import { DoorstroomStatus } from '../enums/DoorstroomStatus';
import { TussentijdseUitstroomVSO } from '../enums/TussentijdseUitstroomVSO';
import { TussentijdseUitstroomVSOStatus } from '../enums/TussentijdseUitstroomVSOStatus';
import { Uitstroom } from '../enums/Uitstroom';
import { Uitstroommoment } from '../enums/Uitstroommoment';
import { Uitstroomtype } from '../enums/Uitstroomtype';
import { UitstroomtypeVSO } from '../enums/UitstroomtypeVSO';

export const fac_ds_doorstroom: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "fac_ds_doorstroom",
	"description": "Definitie voor fact tabel fac_ds_doorstroom uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.FacTable",
		"nl.topicus.cumlaude.metadata.table.Leerlingspecifiek",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek"
	],
	"properties": {
		"ds_co_brin_svh": {
			"type": "string",
			"label": "Instellingscode SvH",
			"category": "Vooropleiding",
			"searchKeys": [
				"school van herkomst",
				"BRIN",
				"BRIN SvH"
			],
			"example": "02AA",
			"description": "Het BRIN-nummer van de school van herkomst.\nDit kan zowel een basisschool zijn als een VO-school, afhankelijk van wat in het bronsysteem is ingericht."
		},
		"ds_co_brin_van": {
			"type": "string",
			"label": "Instellingscode",
			"searchKeys": [
				"BRIN"
			],
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_d_geldig_tot": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_d_geldig_va": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_d_plaatsing_tm": {
			"type": "string",
			"format": "date",
			"label": "Plaatsing t/m",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_d_plaatsing_va": {
			"type": "string",
			"format": "date",
			"label": "Plaatsing vanaf",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_d_plaatsing_va_volgend": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fk_br_vest_naar": {
			"labelSuffix": "volgend schooljaar",
			"exclude": [
				"br_nm_brin_kort"
			],
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"ds_fk_br_vest_van": {
			"description": "Definitie voor dimension tabel dim_br_brin uit de CumLaude DWH",
			"type": "object",
			"schema": dim_br_brin
		},
		"ds_fk_ilt_naar": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"ilt_abb_profiel",
				"ilt_nm_niveau",
				"ilt_nm_profiel"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"ds_fk_ilt_van": {
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"ds_fk_ilt_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"ilt_nm_niveau"
			],
			"description": "Definitie voor dimension tabel dim_ilt_opleidingscode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ilt_opleidingscode
		},
		"ds_fk_inst": {
			"description": "Definitie voor sys tabel instelling uit de CumLaude sys",
			"type": "object",
			"schema": instelling
		},
		"ds_fk_lb_naar": {
			"labelSuffix": "volgend schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"ds_fk_lb_van": {
			"exclude": [
				"lb_co_brin_svh",
				"lb_co_brin_vestiging",
				"lb_is_bevorderd",
				"lb_is_succesvol",
				"lb_nm_examenstatus",
				"lb_nm_idu",
				"lb_nm_klas",
				"lb_nm_opleiding",
				"lb_nm_uitstroom_in_schooljaar",
				"lb_nm_uitstroommoment_in_schooljaar",
				"lb_nm_uitstroomtype_in_schooljaar",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"ds_fk_lb_vorig_sj": {
			"labelSuffix": "vorig schooljaar",
			"include": [
				"lb_abb_leerfase",
				"lb_co_brin",
				"lb_co_brin_vestiging",
				"lb_nm_idu",
				"lb_nm_klas",
				"lb_nm_leerfase",
				"lb_nm_opleiding",
				"lb_nm_vestiging",
				"lb_nr_leerjaar"
			],
			"description": "Definitie voor fact tabel fac_lb_loopbaan uit de CumLaude DWH",
			"type": "object",
			"schema": fac_lb_loopbaan
		},
		"ds_fk_ll": {
			"description": "Definitie voor dimension tabel dim_ll_leerling uit de CumLaude DWH",
			"type": "object",
			"schema": dim_ll_leerling
		},
		"ds_fk_mw_mentor1": {
			"labelOverride": {
				"mw_abb_medewerker": "Eerste mentor (afkorting)",
				"mw_nm_medewerker": "Eerste mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de eerste mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de eerste mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"ds_fk_mw_mentor2": {
			"labelOverride": {
				"mw_abb_medewerker": "Tweede mentor (afkorting)",
				"mw_nm_medewerker": "Tweede mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de tweede mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de tweede mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"ds_fk_mw_mentor_indiv": {
			"labelOverride": {
				"mw_abb_medewerker": "Individuele mentor (afkorting)",
				"mw_nm_medewerker": "Individuele mentor"
			},
			"categoryOverride": {
				"mw_abb_medewerker": "Opleiding",
				"mw_nm_medewerker": "Opleiding"
			},
			"descriptionOverride": {
				"mw_abb_medewerker": "De afkorting van de individuele mentor.",
				"mw_nm_medewerker": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de individuele mentor."
			},
			"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
			"type": "object",
			"schema": dim_mw_medewerker
		},
		"ds_fk_or_bbscl": {
			"include": [],
			"description": "Definitie voor fact tabel fac_or_onderwijsresultaten uit de CumLaude DWH.\nEen onderwijsresultaat uit het onderwijsresultatenmodel aan de hand waarvan de Onderwijsinspectie alle VO-scholen beoordeelt.\nIedere rij stelt één onderwijsresultaat voor: een score op één van de vier indicatoren over één schooljaar voor één vestiging en eventueel niveau (alleen Bovenbouwsucces/Examencijfers).\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Er wordt ook een gemiddelde berekend als van slechts twee schooljaren, waaronder het meest recente schooljaar, gegevens bekend zijn.",
			"type": "object",
			"schema": fac_or_onderwijsresultaten
		},
		"ds_fk_or_obscl": {
			"include": [],
			"description": "Definitie voor fact tabel fac_or_onderwijsresultaten uit de CumLaude DWH.\nEen onderwijsresultaat uit het onderwijsresultatenmodel aan de hand waarvan de Onderwijsinspectie alle VO-scholen beoordeelt.\nIedere rij stelt één onderwijsresultaat voor: een score op één van de vier indicatoren over één schooljaar voor één vestiging en eventueel niveau (alleen Bovenbouwsucces/Examencijfers).\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Er wordt ook een gemiddelde berekend als van slechts twee schooljaren, waaronder het meest recente schooljaar, gegevens bekend zijn.",
			"type": "object",
			"schema": fac_or_onderwijsresultaten
		},
		"ds_fk_or_opcl": {
			"include": [],
			"description": "Definitie voor fact tabel fac_or_onderwijsresultaten uit de CumLaude DWH.\nEen onderwijsresultaat uit het onderwijsresultatenmodel aan de hand waarvan de Onderwijsinspectie alle VO-scholen beoordeelt.\nIedere rij stelt één onderwijsresultaat voor: een score op één van de vier indicatoren over één schooljaar voor één vestiging en eventueel niveau (alleen Bovenbouwsucces/Examencijfers).\nIn de beoordeling van een bepaald peiljaar berekent de inspectie voor iedere indicator het gemiddelde van de onderwijsresultaten over de 3 voorafgaande schooljaren. Er wordt ook een gemiddelde berekend als van slechts twee schooljaren, waaronder het meest recente schooljaar, gegevens bekend zijn.",
			"type": "object",
			"schema": fac_or_onderwijsresultaten
		},
		"ds_fk_pc_leerling_naar": {
			"description": "Definitie voor dimension tabel dim_pc_postcode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_pc_postcode
		},
		"ds_fk_pc_leerling_van": {
			"description": "Definitie voor dimension tabel dim_pc_postcode uit de CumLaude DWH",
			"type": "object",
			"schema": dim_pc_postcode
		},
		"ds_fk_vs_van": {
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"ds_fk_vs_naar": {
			"labelSuffix": "volgend schooljaar",
			"include": [],
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"ds_fk_vs_bekostiging_van": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"ds_fk_vs_bekostiging_naar": {
			"include": [],
			"description": "Definitie voor dimension tabel dim_vs_vestiging uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vs_vestiging
		},
		"ds_fun_nr_abs_verschil_einduitstroomniveau_vso": {
			"type": "number",
			"label": "Absoluut verschil behaald/beoogd uitstroomniveau VSO",
			"category": "Prestatieanalyse",
			"example": "0,0 - 6,5",
			"description": "Het absolute verschil tussen de door de inspectie toegekende puntenaantallen voor het in het (nieuwste) OPP vastgelegde beoogde uitstroomniveau\nen het bij de uitschrijving geregistreerde behaalde uitstroomniveau. Dit is ten behoeve van de indicator \"Beoogd i.r.t. behaald einduitstroomniveau\"\nin de Prestatieanalyse in het VSO. Bij een verschil van 0,0 hebben beide niveaus een gelijk puntenaantal. Bij een grotere waarde kan het behaalde\nniveau zowel hoger als lager zijn dan het beoogde niveau.\nDit veld is alleen gevuld voor VSO-leerlingen die uitstromen met een diploma (Einduitstroom).",
			"blocklist": {
				"geenVSO": true
			}
		},
		"ds_fun_nm_brinvest_overgang": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_nm_doorstroom_ext": {
			"label": "Doorstroom",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": DoorstroomExt
		},
		"ds_fun_is_ergens_overgang": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_is_plaatsing_actueel": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Actuele plaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Voor het huidige schooljaar: Ja als deze plaatsing op dit moment actief is.\nVoor schooljaren in het verleden: Ja als de plaatsing aan het einde van het schooljaar actief was."
		},
		"ds_fun_is_plaatsing_peildatum_1april": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-aprilplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 april van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 april wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1aug": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-augustusplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 augustus van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 augustus wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1dec": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-decemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 december van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 december wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1feb": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-februariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 februari van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 februari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1jan": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-januariplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 januari van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 januari wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1juli": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juliplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 juli van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 juli wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1juni": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-juniplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 juni van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 juni wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1mei": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-meiplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 mei van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 mei wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1mrt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-maartplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 maart van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 maart wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1nov": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-novemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 november van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 november wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-oktoberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 oktober van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 oktober wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_1sep": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-septemberplaatsing",
			"category": "Plaatsing",
			"searchKeys": [
				"Peildatum"
			],
			"example": "Ja, Nee",
			"description": "Geeft aan of deze plaatsing ook actief was op 1 september van dit schooljaar.\nIndien Nee, kan het zijn dat de leerling op 1 september wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_is_plaatsing_peildatum_actueel": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"description": "Geeft aan of deze plaatsing ook actief was aan het einde van dit schooljaar, of vandaag in het lopende schooljaar.\nIndien Nee, kan het zijn dat de leerling aan het einde van het schooljaar wel een andere plaatsing had (met mogelijk een ander leerjaar, niveau of klas)."
		},
		"ds_fun_nm_leerfase_plus_vavo": {
			"type": "string",
			"label": "Leerfase met VAVO",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_nm_nationaliteit": {
			"type": "string",
			"label": "Nationaliteit",
			"category": "Leerling",
			"grouping": false,
			"exportable": false,
			"example": "Nederlandse, Turkse, ...",
			"description-magister": "De eerste of tweede nationaliteit van deze leerling.",
			"description-somtoday": "De eerste of tweede nationaliteit van deze leerling.\nIndien in Somtoday de nationaliteit volgens het BRP is ingevuld, wordt dit \nveld gebruikt, tenzij het vinkje \"wijkt bewust af\" is ingeschakeld."
		},
		"ds_fun_nm_niveau_bbs_van": {
			"label": "Niveau",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Niveau
		},
		"ds_fun_nm_niveau_volgend_sj": {
			"type": "string",
			"label": "Niveau volgend schooljaar",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_nm_onderwijstype": {
			"label": "Onderwijstype",
			"category": "Opleiding",
			"example": "Regulier, Speciaal",
			"description": "Het type onderwijs dat de vestiging verzorgt waarop de leerling is geplaatst: Speciaal als dit Voortgezet Speciaal Onderwijs betreft, anders Regulier.",
			"type": "string",
			"schema": Onderwijstype
		},
		"ds_fun_nm_overgangmoment": {
			"label": "Overgangmoment",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Overgangmoment
		},
		"ds_fun_nr_plaatsing_advies_score": {
			"type": "number",
			"label": "Pl./adviesverschil (score)",
			"category": "Plaatsing",
			"example": "-1; 0; 0,5; 1",
			"description": "De score die de inspectie toekent voor deze leerling op basis van het verschil tussen het niveau van deze plaatsing met het basisschooladvies:\n- -1 als het niveau van deze plaatsing lager is dan het basisschooladvies\n- 0 als het niveau van deze plaatsing gelijk is aan het basisschooladvies\n- 0,5 als het niveau van deze plaatsing HAVO / VWO is, en het basisschooladvies HAVO\n- 1 als het niveau van deze plaatsing hoger is dan het basisschooladvies\n\nBij dubbele adviezen (bijvoorbeeld VMBO b / VMBO k) wordt vergeleken met het laagste; bij driedubbele adviezen (VMBO k t/m HAVO) met het middelste (VMBO (g)t).\nDe score voor de eerste plaatsing in leerjaar 3 wordt gebruikt in de berekening van de indicator Onderwijspositie in het onderwijsresultatenmodel."
		},
		"ds_fun_nr_plaatsing_advies_verschil": {
			"type": "number",
			"label": "Pl./adviesverschil (niveaus)",
			"category": "Plaatsing",
			"example": "0; -1,5; 2; -0,5; ...",
			"description": "Het aantal niveaus verschil tussen het niveau van deze plaatsing en het basisschooladvies. Bij en positief aantal zit de leerling boven niveau; bij een negatief aantal onder niveau.\nHalve niveaus ontstaan bij dubbele adviezen en/of gecombineerde niveaus, zoals VMBO b / VMBO k en HAVO / VWO."
		},
		"ds_fun_nr_plaatsing_lj3_advies_score": {
			"type": "number",
			"label": "Pl./adviesverschil lj3 (score)",
			"category": "Plaatsing",
			"example": "-1; 0; 0,5; 1",
			"description": "De score die de inspectie toekent voor deze leerling op basis van het verschil tussen het niveau van de eerste plaatsing in leerjaar 3 met het basisschooladvies:\n- -1 als het niveau van leerjaar 3 lager is dan het basisschooladvies\n- 0 als het niveau van leerjaar 3 gelijk is aan het basisschooladvies\n- 0,5 als het niveau van leerjaar 3 HAVO / VWO is, en het basisschooladvies HAVO\n- 1 als het niveau van leerjaar 3 hoger is dan het basisschooladvies\n\nBij dubbele adviezen (bijvoorbeeld VMBO b / VMBO k) wordt vergeleken met het laagste; bij driedubbele adviezen (VMBO k t/m HAVO) met het middelste (VMBO (g)t).\nDeze score wordt gebruikt in de berekening van de indicator Onderwijspositie in het onderwijsresultatenmodel."
		},
		"ds_fun_nr_plaatsing_lj3_advies_verschil": {
			"type": "number",
			"label": "Pl./adviesverschil lj3 (niveaus)",
			"category": "Plaatsing",
			"example": "0; -1,5; 2; -0,5; ...",
			"description": "Het aantal niveaus verschil tussen het niveau van de eerste plaatsing in leerjaar 3 van deze leerling en het basisschooladvies. Bij en positief aantal zit de leerling boven niveau; bij een negatief aantal onder niveau.\nHalve niveaus ontstaan bij dubbele adviezen en/of gecombineerde niveaus, zoals VMBO b / VMBO k en HAVO / VWO."
		},
		"ds_fun_is_uitstroom_extern_matrix": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_nm_categorie_uitstroomniveau_vso": {
			"label": "Categorie uitstroomniveau VSO",
			"category": "Prestatieanalyse",
			"example": "Vervolgonderwijs, Arbeid",
			"description": "Vervolgonderwijs of Arbeid, afhankelijk van het bij de uitschrijving vastgelegde behaalde uitstroomniveau.\nDit is ten behoeve van de indicator \"Behaald uitstroomniveau vervolgonderwijs versus arbeid\" in de Prestatieanalyse in het VSO.\nHet veld is alleen van toepassing voor leerlingen die het VSO verlaten.",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": CategorieUitstroomniveauVSO
		},
		"ds_fun_nm_vergelijk_einduitstroomniveau_vso": {
			"label": "Vergelijking uitstroomniveau VSO",
			"category": "Prestatieanalyse",
			"example": "Onder niveau, Op niveau, Boven niveau",
			"description": "Vergelijkt het in het (nieuwste) OPP vastgelegde beoogde uitstroomniveau met het bij de uitschrijving geregistreerde\nbehaalde uitstroomniveau. Dit is ten behoeve van de indicator \"Behaald uitstroomniveau op school conform OPP\"\nin de Prestatieanalyse in het VSO. De puntenaantallen die de inspectie toekent aan beide niveaus worden met elkaar\nvergeleken. Hierbij zijn de volgende uitkomsten mogelijk:\n- Op niveau: De puntenaantallen van beide uitstroomniveaus zijn gelijk.\n- Onder niveau: Het puntenaantal van het beoogde niveau is hoger dan van het behaalde niveau.\n- Boven niveau: Het puntenaantal van het behaalde niveau is hoger dan van het beoogde niveau.\n- Onbekend: De leerling stroomt niet uit bij het VSO, heeft geen uitstroomtype Einduitstroom, of het beoogde of behaalde uitstroomniveau is niet bekend.",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": VergelijkingUitstroomniveauVSO
		},
		"ds_fun_co_verschil_basisschooladvies_van": {
			"type": "string",
			"label": "Basisschooladvies",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_co_verschil_basisschooladvies_naar": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_nr_verschil_einduitstroomniveau_vso": {
			"type": "number",
			"label": "Verschil behaald/beoogd uitstroomniveau VSO",
			"category": "Prestatieanalyse",
			"example": "-6,5 - 6,5",
			"description": "Het verschil tussen de door de inspectie toegekende puntenaantallen voor het in het (nieuwste) OPP vastgelegde beoogde uitstroomniveau\nen het bij de uitschrijving geregistreerde behaalde uitstroomniveau. Dit is ten behoeve van de indicator \"Beoogd i.r.t. behaald einduitstroomniveau\"\nin de Prestatieanalyse in het VSO. Bij een verschil van 0,0 hebben beide niveaus een gelijk puntenaantal. Bij een positieve waarde is het behaalde \nniveau hoger dan het beoogde niveau, bij een negatieve waarde lager.\nDit veld is alleen gevuld voor VSO-leerlingen die uitstromen met een diploma (Einduitstroom).\nNB dit veld betreft niet de inspectie-indicator; die is gebaseerd op het absolute verschil.",
			"blocklist": {
				"geenVSO": true
			}
		},
		"ds_is_1febr_plaatsing_van": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-februariplaatsing",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_1okt_plaatsing_van": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "1-oktoberplaatsing",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_afgewezen": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_afstroom": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_apcg_van": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "APCG",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_bevorderd": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Bevorderd",
			"category": "Doorstroom",
			"example": "Ja, Nee",
			"description": "Ja als de leerling volgend schooljaar in een hoger leerjaar is geplaatst (ongeacht niveau), geslaagd is of uitstroomt met vertrekstatus\nBevorderd of Geslaagd.\nNee in overige gevallen."
		},
		"ds_is_cohortrendement_tot_doublure": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_cohortrendement_vanaf_doublure": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_doorstroom": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_doublure": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_examenkandidaat_van": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Examenkandidaat",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_examenopstroom_van": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Examenopstroom",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_examenprognose": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_geslaagd": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_instroom_extern_van": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_laatste_plaatsing_sj_van": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Laatste plaatsing schooljaar",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_opstroom": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_plaatsing_opeenvolgend": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_prognose": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Doorstroom is prognose",
			"category": "Doorstroom",
			"example": "Ja, Nee",
			"description-somtoday": "Ja als de Doorstroom van deze plaatsing is bepaald op basis van een adviesplaatsing of voorlopige plaatsing.",
			"description-magister": "Ja als de Doorstroom van deze plaatsing is bepaald op basis van een voorlopige plaatsing."
		},
		"ds_is_relevante_doorstroom": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_succesvol": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Succesvol",
			"category": "Doorstroom",
			"example": "Ja, Nee",
			"description": "Ja als deze leerling is bevorderd (mits niet afgestroomd), geslaagd is, opstroomt naar een hoger niveau in hetzelfde leerjaar, of\nuitstroomt met vertrekstatus Bevorderd of Geslaagd.\nNee in overige gevallen."
		},
		"ds_is_uitstroom": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_uitstroom_extern": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_uitstroom_intern": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_uitstroom_vavo": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_is_vest_relevant_sj_van": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_nm_examenstatus": {
			"label": "Examenstatus",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Examenstatus
		},
		"ds_fun_nm_examenstatus_met_prognose": {
			"label": "Examenstatus",
			"category": "Examen",
			"searchKeys": [
				"Geslaagd",
				"Afgewezen",
				"Teruggetrokken",
				"Voorlaatste jaar",
				"Gespreid examen",
				"Gezakt"
			],
			"example": "Geslaagd, Afgewezen, Geslaagd (prognose), Afgewezen (prognose), ...",
			"description": "De uitslag van het examen of de status waarin het examen zich bevindt:\n- Geslaagd: de leerling is geslaagd of is uitgeschreven met vertrekstatus Geslaagd.\n- Afgewezen: de leerling is afgewezen (gezakt) of is uitgeschreven met vertrekstatus Afgewezen.\n- Teruggetrokken: de leerling heeft zich voor of tijdens het examen teruggetrokken en niet langer examenkandidaat.\n- Voorlaatste jaar: de leerling zit in het (voor)voorlaatste jaar van de opleiding en doet dit jaar in één of meer vakken examen.\n- Gespreid examen: de leerling zit in het eerste jaar van een gespreid examen en doet dit jaar examen in een deel van de vakken.\n\nDe aanduiding (prognose) bij Geslaagd of Afgewezen geeft aan dat er nog geen uitslag is, maar wat de uitslag zou zijn op basis van de SE-cijfers van de leerling.\nOm alleen leerlingen op te vragen die dit jaar examen doen, is het raadzaam om te filteren op het veld Examenkandidaat.",
			"type": "string",
			"schema": ExamenstatusMetPrognose
		},
		"ds_fun_nm_instroommoment": {
			"type": "string",
			"label": "Instroommoment",
			"filter": false,
			"category": "Doorstroom",
			"example": "T/m 1 oktober, Na 1 oktober, Na 1 november, ...",
			"description": "Het moment binnen het schooljaar waarin de leerling is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 'T/m 1 oktober', anders 'Na' de voorgaande eerste van de maand (oktober t/m juli).\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"ds_fun_nr_maanden_instroom_na_1okt": {
			"type": "integer",
			"minimum": 0,
			"maximum": 10,
			"label": "Instroommoment",
			"grouping": false,
			"exportable": false,
			"category": "Doorstroom",
			"example": "0 - 10",
			"description": "Het aantal maanden (afgerond naar boven) tussen 1 oktober van dit schooljaar en het moment van instroom, mits deze leerling dit schooljaar is ingestroomd vanuit een andere school of vestiging.\nIndien de leerling is ingestroomd op of voor 1 oktober van dit schooljaar, is deze waarde 0.\nLeeg als deze leerling dit schooljaar niet is ingestroomd vanuit een andere school of vestiging."
		},
		"ds_fun_is_pro_volgend_sj": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_is_uitstroom_hoger_onderwijs_geen_uitslag": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_fun_is_uitstroom_speciaal_onderwijs": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nm_bbs_uitzondering_van": {
			"label": "Bovenbouwsucces uitzondering",
			"category": "Uitzonderingen",
			"example": "Uitgesloten van ROD-communicatie, Geen bovenbouw, ...",
			"blocklist": {
				"geenVO": true
			},
			"description": "Geeft aan of er een bijzondere situatie van toepassing is op deze leerling waardoor deze plaatsing niet meetelt voor de indicator Bovenbouwsucces:\n- Regulier bovenbouwsucces: geen uitzondering van toepassing; de plaatsing telt mee voor het bovenbouwsucces.\n- VSO: de leerling is geplaatst op het VSO; het bovenbouwsucces is niet van toepassing.\n- Geen bovenbouw: de leerling zit niet in leerjaar 3, 4, 5 of 6.\n- Geen relevante plaatsing: deze plaatsing is niet de plaatsing van de leerling die relevant is voor het bovenbouwsucces. De relevante\n  plaatsing is de plaatsing die actief is op 1 oktober.\n- Geen 1-oktoberplaatsing: deze plaatsing is beëindigd vóór 1 oktober van dit schooljaar.\n- Tussentijdse instroom: deze plaatsing begint na 1 oktober van dit schooljaar.\n- Doorstroom hoger onderwijs zonder uitslag: de leerling stroomt zonder uitslag vanuit VMBO of HAVO door naar het Hoger Onderwijs.\nDeze groep leerlingen wordt buiten beschouwing gelaten. VWO-leerlingen die zonder uitslag naar het HO gaan, tellen wel mee en zijn niet\nsuccesvol.\n- Overgang naar praktijkonderwijs: leerlingen die uitstromen naar het praktijkonderwijs tellen niet mee voor het bovenbouwsucces.\n- Uitgesloten van ROD-communicatie: de leerling is uitgesloten van ROD-communicatie en telt niet mee bij het bovenbouwsucces.\n- VAVO leerling: VAVO-leerlingen tellen niet mee voor het bovenbouwsucces.\n- Internationale leerling: leerlingen met de internationale opleidingen \"International Baccalaureate\" en \"European Secondary School\"\ntellen niet mee voor het bovenbouwsucces.\n- Nieuwkomer: de leerling verblijft op 1 oktober van dit schooljaar korter dan 2 jaar in Nederland en telt daarom niet mee voor het\nbovenbouwsucces.\n- Uitstroom speciaal onderwijs: leerlingen die uitstromen naar het speciaal onderwijs tellen niet mee voor het bovenbouwsucces.\n- Vakmanschap/technologie-route: tot schooljaar 2018/2019 telden leerlingen in de vakmanschap/technologie-route niet mee voor het\nbovenbouwsucces.",
			"type": "string",
			"schema": BovenbouwsuccesUitzondering
		},
		"ds_nm_bekostigingstype_van": {
			"label": "Bekostigingstype",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Bekostigingstype
		},
		"ds_nm_bron": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nm_cohortrendement_tot_cohortrendement": {
			"label": "Cohortrendement (tot)",
			"category": "Doorstroom",
			"example": "Onder advies, Zonder vertraging, Boven advies, Gedoubleerd, ...",
			"description": "Geeft aan hoe de loopbaan van de leerling is verlopen tot en met deze plaatsing, vergeleken met het basisschooladvies en de nominale onderwijsduur:\n- Onder advies: het niveau van deze plaatsing is lager dan het basisschooladvies; er is geen sprake van doublures\n- Onder advies & gedoubleerd: het niveau van deze plaatsing is lager dan het basisschooladvies en is sprake van één of meer doublures\n- Gedoubleerd: het niveau van deze plaatsing is gelijk aan het basisschooladvies en er is sprake van één of meer doublures\n- Zonder vertraging: het niveau van deze plaatsing is gelijk aan het basisschooladvies en er is geen sprake van doublures\n- Boven advies: het niveau van deze plaatsing is hoger dan het basisschooladvies; er is geen sprake van doublures\n- Boven advies & gedoubleerd: het niveau van deze plaatsing is hoger dan het basisscholadvies en er sprake van één of meer doublures\n\nDe indicatie (prognose) geeft aan dat deze waarde is bepaald op basis van een adviesplaatsing of voorlopige plaatsing.",
			"type": "string",
			"schema": CohortrendementTotWaarde
		},
		"ds_nm_cohortrendement_tot_doublures": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": CohortrendementTotDoublure
		},
		"ds_nm_cohortrendement_tot_niveauverschil": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": CohortrendementTotNiveau
		},
		"ds_nm_cohortrendement_vanaf_cohortrendement": {
			"label": "Cohortrendement (vanaf)",
			"category": "Doorstroom",
			"example": "Afgestroomd, Gedoubleerd, Zonder vertraging, ...",
			"description": "Geeft aan hoe de loopbaan van de leerling is verlopen vanaf deze plaatsing tot en met het (laatste) eindexamen, waarbij het niveau en de nominale onderwijsduur vergeleken worden:\n- Afgestroomd: de leerling heeft examen gedaan op een lager niveau dan deze plaatsing; er is geen sprake van doublures\n- Afgestroomd & gedoubleerd: de leerling heeft examen gedaan op een lager niveau dan deze plaatsing en er is sprake van één of meer doublures\n- Gedoubleerd: de leerling heeft examen gedaan op het niveau van deze plaatsing en er is sprake van één of meer doublures\n- Zonder vertraging: de leerling heeft examen gedaan op het niveau van deze plaatsing en er is geen sprake van doublures\n- Opgestroomd: de leerling heeft examen gedaan op een hoger niveau dan deze plaatsing; er is geen sprake van doublures\n- Opgestroomd & gedoubleerd: de leerling heeft examen gedaan op een hoger niveau dan deze plaatsing en er is sprake van één of meer doublures",
			"type": "string",
			"schema": CohortrendementVanafWaarde
		},
		"ds_nm_cohortrendement_vanaf_doublures": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": CohortrendementVanafDoublure
		},
		"ds_nm_cohortrendement_vanaf_niveauverschil": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": CohortrendementVanafNiveau
		},
		"ds_nm_cohortstatus_examenopstroom": {
			"label": "Cohortstatus (examenopstroom)",
			"category": "Doorstroom",
			"example": "Volledig cohort gevolgd, Nog bezig, Tussentijds uitgestroomd",
			"description": "Geeft aan of deze examenopstromer na deze plaatsing zijn of haar loopbaan heeft afgemaakt op deze instelling:\n- Volledig cohort gevolgd: de leerling heeft na dit examen de opleiding op een hoger niveau vervolgd en daarvoor op deze instelling een diploma behaald\n- Tussentijds uitgestroomd: de leerling heeft na dit examen de opleiding op een hoger niveau vervolgd, maar is uitgestroomd voordat daarvoor een diploma was behaald\n- Nog bezig: de leerling heeft na dit examen de opleiding op een hoger niveau vervolgd, maar heeft daarvoor nog geen diploma behaald en is ook nog niet uitgestroomd\n\nDit veld is alleen gevuld als de leerling in het schooljaar van deze plaatsing examenkandidaat is, en na dat schooljaar opstroomt naar een hoger niveau.",
			"type": "string",
			"schema": CohortstatusVanaf
		},
		"ds_nm_cohortstatus_vanaf": {
			"label": "Cohortstatus (vanaf)",
			"category": "Doorstroom",
			"example": "Volledig cohort gevolgd, Nog bezig, Tussentijds uitgestroomd",
			"description": "Geeft aan of deze leerling na deze plaatsing zijn of haar loopbaan heeft afgemaakt op deze instelling:\n- Volledig cohort gevolgd: de leerling heeft na deze plaatsing op deze instelling een diploma behaald\n- Tussentijds uitgestroomd: de leerling is na deze plaatsing uitgestroomd voordat een diploma was behaald\n- Nog bezig: de leerling heeft na deze plaatsing nog geen diploma behaald en is ook nog niet uitgestroomd",
			"type": "string",
			"schema": CohortstatusVanaf
		},
		"ds_nm_einduitstroom_vso_status": {
			"label": "Einduitstroom status",
			"category": "Prestatieanalyse",
			"example": "Informatie volledig, Geen behaald uitstroomniveau geregistreerd bij uitschrijving, ...",
			"description": "Geeft aan of alle gegevens aanwezig zijn die nodig zijn om indicator 'Behaald einduitstroomniveau onderwijs vs arbeid' binnen de prestatieanalyse te bepalen:\n- Informatie volledig: alle gegevens zijn aanwezig\n- Geen behaald uitstroomniveau geregistreerd bij uitschrijving: er is geen uitstroomniveau vastgelegd bij de uitschrijvingsgegevens van de leerling.\nHierdoor kan niet worden bepaald of de leerling uitstroomt op het niveau van vervolgonderwijs of arbeid.\n- Ongeldig behaald uitstroomniveau geregistreerd bij uitschrijving: er is wel een uitstroomniveau vastgelegd bij de uitschrijvingsgegevens van de leerling, maar dit wordt niet door CumLaude herkend.\n- Niet uitgeschreven: de leerling is nog niet uitgeschreven en telt daarom niet mee voor de prestatieanalyse.\n- Geen einduitstroom: de leerling heeft geen diploma behaald en telt daarom niet mee bij einduitstroom.",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": EinduitstroomVSOStatus
		},
		"ds_nm_examenrendement_cohortrendement": {
			"label": "Examenrendement",
			"category": "Doorstroom",
			"example": "Onder advies, Zonder vertraging, Boven advies, Gedoubleerd, ...",
			"description": "Geeft aan hoe de loopbaan van de examenkandidaat is verlopen tot en met deze plaatsing, vergeleken met het basisschooladvies en de nominale onderwijsduur:\n- Onder advies: het niveau van deze plaatsing is lager dan het basisschooladvies; er is geen sprake van doublures\n- Onder advies & gedoubleerd: het niveau van deze plaatsing is lager dan het basisschooladvies en is sprake van één of meer doublures\n- Gedoubleerd: het niveau van deze plaatsing is gelijk aan het basisschooladvies en er is sprake van één of meer doublures\n- Zonder vertraging: het niveau van deze plaatsing is gelijk aan het basisschooladvies en er is geen sprake van doublures\n- Boven advies: het niveau van deze plaatsing is hoger dan het basisschooladvies; er is geen sprake van doublures\n- Boven advies & gedoubleerd: het niveau van deze plaatsing is hoger dan het basisscholadvies en er sprake van één of meer doublures\n- Afgewezen: de examenkandidaat is niet geslaagd.\n\nDe indicatie (prognose) geeft aan dat deze waarde is bepaald op basis van een adviesplaatsing of voorlopige plaatsing.\nVoor leerlingen die geen examen doen is dit veld niet gevuld.",
			"type": "string",
			"schema": CohortrendementTotWaarde
		},
		"ds_nm_examenrendement_doublures": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": CohortrendementTotDoublure
		},
		"ds_nm_idu": {
			"label": "Doorstroom",
			"category": "Doorstroom",
			"searchKeys": [
				"Opstroom",
				"Afstroom",
				"Doorstroom",
				"Geslaagd",
				"Afgewezen"
			],
			"example": "Doorstroom, Geslaagd, Afstroom, ...",
			"description": "Geeft aan wat het doorstroomresultaat van deze plaatsing is:\n- Doorstroom: de leerling gaat naar een hoger leerjaar op hetzelfde niveau\n- Doublure: de leerling gaat naar hetzelfde leerjaar op hetzelfde niveau, of de leerling stroomt zonder diploma uit naar het MBO\n- Opstroom: de leerling gaat naar een hoger niveau (ongeacht leerjaar)\n- Afstroom: de leerling gaat naar een lager niveau (ongeacht leerjaar)\n- Geslaagd: de leerling is examenkandidaat en heeft examenstatus Geslaagd\n- Afgewezen: de leerling is examenkandidaat en heeft examenstatus Afgewezen; er is nog geen vervolgplaatsing\n- Geen: de leerling heeft binnen hetzelfde schooljaar een volgende plaatsing met hetzelfde leerjaar en niveau\n\nWanneer dit veld leeg is, is het doorstroomresultaat onbekend omdat het niveau en/of leerjaar van deze of de volgende plaatsing onbekend is, \nof bij een uitstromende leerling het niveau en/of leerjaar op de school van bestemming onbekend is.\nBij dashboards die 1-oktoberplaatsingen tonen, is het Doorstroomveld gebaseerd op het niveau en leerjaar van deze plaatsing ten opzichte van de volgende 1-oktoberplaatsing.\nBij dashboards die de volledige loopbaan van een leerling volgen, zoals Details > Leerling, is dit veld gebaseerd op het niveau en leerjaar van deze plaatsing ten opzichte van de volgende plaatsing, die mogelijk in hetzelfde schooljaar ligt.",
			"type": "string",
			"schema": DoorstroomResultaat
		},
		"ds_nm_instroom_in_schooljaar": {
			"label": "Instroom",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Instroom
		},
		"ds_nm_instroom_van": {
			"label": "Instroom",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Instroom
		},
		"ds_nm_instroomtype_in_schooljaar": {
			"label": "Instroomtype",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Instroomtype
		},
		"ds_nm_instroomtype_van": {
			"label": "Instroomtype",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Instroomtype
		},
		"ds_nm_klas_naar": {
			"type": "string",
			"label": "Klas (naar)",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nm_klas_van": {
			"type": "string",
			"label": "Klas",
			"category": "Opleiding",
			"example": "1V2, 2B3, 3H4, ...",
			"description-somtoday": "De stamgroep van deze leerling, zoals vastgelegd in deze plaatsing.",
			"description-magister": "De klas van deze leerling, zoals vastgelegd in de aanmelding."
		},
		"ds_nm_obs_uitzondering_van": {
			"label": "Onderbouwsnelheid uitzondering",
			"category": "Uitzonderingen",
			"example": "Nieuwkomer, Tussentijdse instroom, Uitstroom/Geen VO, ...",
			"blocklist": {
				"geenVO": true
			},
			"description": "Geeft aan of er een bijzondere situatie van toepassing is op deze leerling waardoor deze plaatsing niet meetelt voor de indicator Onderbouwsnelheid:\n- Reguliere onderbouwsnelheid: geen uitzondering van toepassing; de plaatsing telt mee voor de onderbouwsnelheid.\n- VSO: de leerling is geplaatst op het VSO; de onderbouwsnelheid is niet van toepassing.\n- Geen onderbouw: de leerling is niet geplaatst in leerjaar 1 of 2.\n- Geen 1-oktoberplaatsing: deze plaatsing is beëindigd vóór 1 oktober van dit schooljaar.\n- Tussentijdse instroom: deze plaatsing begint na 1 oktober van dit schooljaar.\n- Uitgesloten van ROD-communicatie: de leerling is uitgesloten van ROD-communicatie en telt niet mee bij de onderbouwsnelheid.\n- Emigratie: leerlingen die het Nederlands VO verlaten tellen niet mee voor de onderbouwsnelheid.\n- Uitstroom speciaal onderwijs: leerlingen die uitstromen naar het speciaal onderwijs tellen niet mee voor de onderbouwsnelheid.\n- Uitstroom/Geen VO: leerlingen die het Nederlands VO verlaten tellen niet mee voor de onderbouwsnelheid.\n- Internationale leerling: leerlingen met de internationale opleidingen \"International Baccalaureate\" en \"European Secondary School\"\ntellen niet mee voor de onderbouwsnelheid.\n- PrO-leerling: leerlingen die uitstromen naar het praktijkonderwijs tellen niet mee voor de onderbouwsnelheid.\n- VAVO leerling: VAVO-leerlingen tellen niet mee voor de onderbouwsnelheid.\n- Nieuwkomer: de leerling verblijft op 1 oktober van dit schooljaar korter dan 2 jaar in Nederland en telt daarom niet mee voor de\nonderbouwsnelheid.",
			"type": "string",
			"schema": OnderbouwsnelheidUitzondering
		},
		"ds_nm_opleiding_bekostiging_van": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nm_opleiding_naar": {
			"type": "string",
			"label": "Opleiding volgend schooljaar",
			"category": "Opleiding",
			"example": "Brugklas, HAVO 3, VWO NT & NG, ...",
			"description": "De opleiding van de leerling zoals vastgelegd in de vervolgplaatsing"
		},
		"ds_nm_opleiding_van": {
			"type": "string",
			"label": "Opleiding",
			"category": "Opleiding",
			"example": "Brugklas, HAVO 3, VWO NT & NG, ...",
			"description": "De opleiding van de leerling zoals vastgelegd in deze plaatsing"
		},
		"ds_nm_opstroomrendement_cohortrendement": {
			"label": "Opstroomrendement",
			"category": "Doorstroom",
			"example": "Onder advies, Zonder vertraging, Boven advies, Gedoubleerd, ...",
			"description": "Geeft aan hoe de loopbaan van deze examenopstromer is verlopen na deze plaatsing (na dit examen) tot en met het laatste eindexamen, waarbij het niveau en de nominale onderwijsduur vergeleken worden:\n- Zonder vertraging: de leerling heeft examen gedaan op het niveau waarnaartoe is opgestroomd en er is geen sprake van doublures\n- Gedoubleerd: de leerling heeft examen gedaan op het niveau waarnaartoe is opgestroomd en er is sprake van één of meer doublures\n- Opgestroomd: de leerling is na het opstromen nogmaals opgestroomd en heeft op dat niveau examen gedaan; er is geen sprake van doublures\n- Opgestroomd & gedoubleerd: de leerling is na het opstromen nogmaals opgestroomd en heeft op dat niveau examen gedaan; daarnaast is sprake van één of meer doublures\n- Afgestroomd: de leerling is na het opstromen weer afgestroomd en heeft examen gedaan op dat lagere niveau; er is geen sprake van doublures\n- Afgestroomd & gedoubleerd: de leerling is na het opstromen weer afgestroomd en heeft examen gedaan op dat lagere niveau; daarnaast is sprake van één of meer doublures\n\nDit veld is alleen gevuld als de leerling in het schooljaar van deze plaatsing examenkandidaat is, en na dat schooljaar opstroomt naar een hoger niveau.",
			"type": "string",
			"schema": CohortrendementVanafWaarde
		},
		"ds_nm_opstroomrendement_doublures": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": CohortrendementVanafDoublure
		},
		"ds_nm_opstroomrendement_niveauverschil": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": CohortrendementVanafNiveau
		},
		"ds_nm_op_status_van": {
			"label": "Onderwijspositie status",
			"category": "Uitzonderingen",
			"example": "Informatie volledig, Advies niet correct in systeem, ...",
			"description": "Geeft aan of alle gegevens aanwezig zijn die nodig zijn om de onderwijspositie te bepalen:\n- Informatie volledig: alle gegevens zijn aanwezig\n- Advies niet correct in systeem: er is geen basisschooladvies (DUO) aanwezig in het bronsysteem\n- Opleiding voor lj3 niet correct in systeem: de plaatsing voor de eerste keer dat de leerling in leerjaar 3 zit is niet aanwezig of heeft geen geldig niveau\n- Doorstroom niet af te leiden uit vertrekstatus: de leerling is uitgeschreven, maar op basis van uitschrijfreden, vertrekstatus of niveau/leerjaar SvB kon geen doorstroomresultaat worden bepaald",
			"type": "string",
			"schema": OnderwijspositieStatus
		},
		"ds_nm_op_uitzondering_van": {
			"label": "Onderwijspositie uitzondering",
			"category": "Uitzonderingen",
			"example": "Combinatieleerweg, Advies breder dan 3, Doublure in lj2, ...",
			"blocklist": {
				"geenVO": true
			},
			"description": "Geeft aan of er een bijzondere situatie van toepassing is op deze leerling waardoor deze plaatsing niet meetelt voor de indicator\nOnderwijspositie t.o.v. advies PO:\n- Reguliere onderwijspositie: geen uitzondering van toepassing; de plaatsing telt mee voor de onderwijspositie.\n- VSO: de leerling is geplaatst op het VSO; de onderwijspositie is niet van toepassing.\n- Geen relevante plaatsing: deze plaatsing is niet de plaatsing van de leerling die relevant is voor de onderwijspositie. De relevante\nplaatsing is de plaatsing die actief is op 1 oktober.\n- Geen 1-oktoberplaatsing: deze plaatsing is beëindigd vóór 1 oktober van dit schooljaar.\n- Tussentijdse instroom: deze plaatsing begint na 1 oktober van dit schooljaar.\n- Geen leerjaar 2: deze plaatsing betreft niet leerjaar 2. Voor de onderwijspositie wordt de plaatsing gezocht waarin de leerling over\ngaat van leerjaar 2 naar 3.\n- Andere school/vestiging in leerjaar 1: deze leerling had in leerjaar 1 een andere vestiging (BRIN) dan in leerjaar 2.\nHierdoor wordt deze leerling bij de bepaling van de onderwijspositie buiten beschouwing gelaten, omdat het verschil tussen het\nbasisschooladvies en de onderwijspositie in leerjaar 3 niet kan worden toegeschreven aan één vestiging.\n- Advies breder dan 3: de leerling heeft een basisschooladvies dat meer dan 3 niveaus beslaat, zoals VMBO b t/m HAVO. Bij adviezen van 2\nniveaus wordt het laagste niveau gebruikt; bij adviezen van 3 niveaus het middelste. Adviezen van meer dan 3 niveaus zijn niet\nbruikbaar.\n- Uitgesloten van ROD-communicatie: de leerling is in leerjaar 2 uitgesloten van ROD-communicatie en telt niet mee bij de onderwijspositie.\n- VSO advies: de leerling had VSO als basisschooladvies; dit advies is niet bruikbaar voor het bepalen van het verschil tussen de\nonderwijspositie t.o.v. het advies PO.\n- Emigratie: leerlingen die het Nederlands VO verlaten tellen niet mee voor de onderwijspositie.\n- Uitstroom speciaal onderwijs: leerlingen die uitstromen naar het speciaal onderwijs tellen niet mee voor de onderwijspositie.\n- Uitstroom/Geen VO: leerlingen die het Nederlands VO verlaten tellen niet mee voor de onderwijspositie.\n- Internationale leerling: leerlingen met de internationale opleidingen \"International Baccalaureate\" en \"European Secondary School\"\ntellen niet mee voor de onderwijspositie.\n- PrO-leerling: leerlingen die uitstromen naar het praktijkonderwijs tellen niet mee voor de onderwijspositie.\n- VAVO leerling: VAVO-leerlingen tellen niet mee voor de onderwijspositie.\n- Nieuwkomer: de leerling verblijft op 1 oktober van dit schooljaar korter dan 2 jaar in Nederland en telt daarom niet mee voor de\nonderwijspositie.",
			"type": "string",
			"schema": OnderwijspositieUitzondering
		},
		"ds_nm_plaatsing_uitzondering": {
			"label": "Plaatsing uitzondering",
			"category": "Uitzonderingen",
			"description": "Geeft aan of er een bijzondere situatie van toepassing is waardoor deze plaatsing niet wordt gebruikt bij het bepalen van doorstroom:\n- Plaatsing telt mee: deze plaatsing wordt gebruikt bij het bepalen van doorstroom\n- Geen relevante plaatsing: deze plaatsing is niet actief op 1 oktober van dit schooljaar, of is niet de laatste plaatsing in het examenjaar\n- Geen 1-oktoberplaatsing: deze plaatsing is beëindigd vóór 1 oktober van dit schooljaar\n- Tussentijdse instroom: deze plaatsing begint na 1 oktober van dit schooljaar",
			"type": "string",
			"schema": PlaatsingUitzondering
		},
		"ds_nm_prestatieanalyse_vso_uitzondering": {
			"label": "Prestatieanalyse uitzondering",
			"category": "Prestatieanalyse",
			"example": "Telt mee voor prestatieanalyse, Minder dan 6 weken ingeschreven",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": PrestatieanalyseVSOUitzondering
		},
		"ds_nm_schooljaar_naar": {
			"type": "string",
			"label": "Schooljaar (naar)",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nm_schooljaar_van": {
			"type": "string",
			"label": "Schooljaar",
			"category": "Doorstroom",
			"filter": false,
			"grouping": false,
			"example": "2022/2023",
			"description": "Het schooljaar van deze plaatsing.\nSchooljaren lopen van 1 augustus tot 31 juli daaropvolgend.\nEen plaatsing duurt nooit langer dan één schooljaar, maar een leerling kan in één schooljaar meerdere plaatsingen hebben, bijvoorbeeld in het geval van een overstap."
		},
		"ds_nm_status": {
			"label": "Doorstroom status",
			"category": "Uitzonderingen",
			"example": "Informatie volledig, Onbekende doorstroom, ...",
			"description": "Geeft aan of alle gegevens aanwezig zijn die nodig zijn om het doorstroomresultaat en (voor zover van toepassing) de onderwijspositie en/of het bovenbouwsucces te bepalen:\n- Informatie volledig: alle gegevens zijn aanwezig\n- Examenstatus niet correct in systeem: de leerling is examenkandidaat en is na dit schooljaar uitgeschreven, maar er is geen examenstatus (Geslaagd of Afgewezen) bekend en kan ook niet worden bepaald op basis van de vertrekstatus of uitschrijfreden\n- (Advies)plaatsing volgend schooljaar nog niet bekend\n- Doorstroom niet af te leiden uit vertrekstatus: de leerling is uitgeschreven, maar op basis van uitschrijfreden, vertrekstatus of niveau/leerjaar SvB kon geen doorstroomresultaat worden bepaald\n- Onbekende doorstroom: de leerling is uitgeschreven, is niet geslaagd of afgewezen, het leerjaar van volgend jaar is nog niet bekend en er kon geen doorstroomresultaat worden bepaald\n- Doorstroom kan door onbekende oorzaak niet worden bepaald: de leerling voldoet aan geen van de mogelijke doorstroomresultaten maar het is niet duidelijk waarom",
			"type": "string",
			"schema": DoorstroomStatus
		},
		"ds_nm_tussentijdse_uitstroom_vso": {
			"label": "Tussentijdse uitstroom (VSO)",
			"category": "Prestatieanalyse",
			"example": "Regulier onderwijs, Speciaal onderwijs",
			"description": "Geeft aan hoe de leerling meetelt voor de indicator 'Tussentijdse uitstroom' binnen de prestatieanalyse:\n- Regulier onderwijs: de leerling stroomt uit naar het reguliere onderwijs (VO, MBO, HBO, VAVO).\n- Speciaal onderwijs: de leerling stroomt uit naar speciaal onderwijs (SO, VSO).\n\nDit veld is alleen gevuld voor leerlingen die het VSO zonder diploma verlaten (Tussentijdse uitstroom) en voor wie de school van bestemming bekend is.",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": TussentijdseUitstroomVSO
		},
		"ds_nm_tussentijdse_uitstroom_vso_status": {
			"label": "Tussentijdse uitstroom status",
			"category": "Prestatieanalyse",
			"example": "Informatie volledig, Geen behaald uitstroomniveau geregistreerd bij uitschrijving, ...",
			"description": "Geeft aan of alle gegevens aanwezig zijn die nodig zijn om indicator 'Tussentijdse uitstroom' binnen de prestatieanalyse te bepalen:\n- Informatie volledig: alle gegevens zijn aanwezig\n- Geen school van bestemming geregistreerd: bij de uitschrijving is geen vervolgschool geregistreerd.\nHierdoor kan niet worden bepaald of er sprake is van uitstroom naar regulier of speciaal onderwijs.\n- Onbekende schoolsoort SvB: er is bij de uitschrijving wel een vervolgschool geregistreerd, maar deze is van een onbekende schoolsoort.\nHierdoor kan niet worden bepaald of er sprake is van uitstroom naar regulier of speciaal onderwijs.\n- Niet uitgeschreven: de leerling is nog niet uitgeschreven en telt daarom niet mee voor de prestatieanalyse.\n- Registratie niet beëindigd: de leerling is na deze plaatsing wel vertrokken van deze instelling, maar de registratie is blijven doorlopen.\nBeëindig de registratie op de vertrekdatum en geef hierbij een vervolgschool aan om deze leerling mee te laten tellen voor de prestatieanalyse.\n- Geen einduitstroom: de leerling heeft geen diploma behaald en telt daarom niet mee bij einduitstroom.",
			"blocklist": {
				"geenVSO": true
			},
			"type": "string",
			"schema": TussentijdseUitstroomVSOStatus
		},
		"ds_nm_uitstroom": {
			"label": "Uitstroom",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Uitstroom
		},
		"ds_nm_uitstroom_in_schooljaar": {
			"label": "Uitstroom",
			"category": "Instroom - Uitstroom",
			"example": "Extern, Intern, Extern (tussentijds), VAVO, ...",
			"description": "Geeft aan of en op welke manier en welk moment de leerling in dit schooljaar de school verlaat:\n- Extern: de leerling verlaat de instelling en stroomt door naar vervolgonderwijs of anders\n- VAVO: de leerling vertrekt naar de VAVO; hij of zij heeft hierna een VAVO-plaatsing\n- Intern: de leerling stroomt door naar een andere vestiging binnen deze instelling\nDit wordt van boven naar beneden bepaald: als een leerling dit schooljaar eerst intern\ndoorstroomt en daarna extern uitstroomt, is dit veld \"Extern\".\nTussentijdse uitstroom (eerder dan 31 juli of 31 mei voor examenleerlingen) wordt\naangegeven met \"(tussentijds)\".",
			"type": "string",
			"schema": Uitstroom
		},
		"ds_nm_uitstroommoment": {
			"label": "Uitstroommoment",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Uitstroommoment
		},
		"ds_nm_uitstroommoment_in_schooljaar": {
			"label": "Uitstroommoment",
			"category": "Instroom - Uitstroom",
			"example": "Einde schooljaar, Tussentijds",
			"description": "Geeft aan of en op welk moment de leerling in dit schooljaar de school verlaat:\n- Einde schooljaar: de uitschrijfdatum (of einddatum van de plaatsing) is op 31 juli (of vanaf 31 mei voor examenleerlingen)\n- Tussentijds: eerder dan 31 juli (of 31 mei voor examenleerlingen)",
			"type": "string",
			"schema": Uitstroommoment
		},
		"ds_nm_uitstroomtype": {
			"label": "Uitstroomtype",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Uitstroomtype
		},
		"ds_nm_uitstroomtype_in_schooljaar": {
			"label": "Uitstroomtype",
			"category": "Instroom - Uitstroom",
			"example": "Extern, Intern",
			"description": "Geeft aan of en op welke manier de leerling in dit schooljaar de school verlaat:\n- Extern: de leerling verlaat de instelling en stroomt door naar vervolgonderwijs of anders\n- VAVO: de leerling vertrekt naar de VAVO; hij of zij heeft hierna een VAVO-plaatsing\n- Intern: de leerling stroomt door naar een andere vestiging binnen deze instelling\nDit wordt van boven naar beneden bepaald: als een leerling dit schooljaar eerst intern\ndoorstroomt en daarna extern uitstroomt, is dit veld \"Extern\".",
			"type": "string",
			"schema": Uitstroomtype
		},
		"ds_nm_uitstroomtype_vso": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": UitstroomtypeVSO
		},
		"ds_nm_vestiging_naar": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nm_vestiging_van": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nr_cohortrendement_tot_niveau": {
			"type": "integer",
			"minimum": -1,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nr_cohortrendement_vanaf_niveau": {
			"type": "integer",
			"minimum": -1,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nr_leerjaar_naar": {
			"type": "integer",
			"minimum": 1,
			"maximum": 6,
			"label": "Leerjaar (naar)",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nr_leerjaar_van": {
			"type": "integer",
			"minimum": 1,
			"maximum": 6,
			"label": "Leerjaar",
			"category": "Opleiding",
			"example": "1, 2, 3, 4, 5, 6",
			"description": "Het leerjaar waarin deze leerling geplaatst is."
		},
		"ds_nr_leerling": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"ds_nr_opstroomrendement_niveau": {
			"type": "integer",
			"minimum": -1,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nr_versie": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"ds_nr_weging": {
			"type": "integer",
			"label": "Weging",
			"category": "Doorstroom",
			"example": "1; 0,5",
			"description-somtoday": "Wanneer dit een plaatsing is met een doorstroomprognose op basis van een adviesplaatsing: de relatieve weging (0-1) die aangeeft hoe\nzwaar deze prognose meetelt. De som van de relatieve wegingen van alle doorstroomprognoses voor een leerling in een schooljaar is altijd 1.\nVoor reguliere plaatsingen (zonder prognose, of een prognose op basis van een voorlopige plaatsing) is de weging 1.",
			"description-magister": "Geeft aan hoe zwaar deze plaatsing meetelt in de doorstroomtotalen. Voor reguliere plaatsingen is de weging altijd 1."
		},
		"ds_pk_key": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
